// @ts-nocheck
import { populate } from 'populate';
import type { Container, Sprite, Text } from 'pixi.js';
import { ButtonLargeLayout } from '../common/buttons/ButtonLargeLayout';

const raw = {
  width: 664,
  height: 667,
  x: 0,
  y: 0,
  list: [
    {
      id: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      type: 'Container',
      runtimeType: null,
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '',
      data: undefined,
      stateByName: {}
    },
    {
      id: '9aaaf1b6-030f-4d79-bcf7-db93bec1bb3d',
      type: 'Container',
      runtimeType: null,
      name: 'popup',
      className: '',
      x: 335,
      y: 385,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: undefined,
      stateByName: {}
    },
    {
      id: '95d277a4-48d9-4457-89db-a8b0faa57854',
      type: 'Sprite',
      runtimeType: null,
      name: 'background',
      className: '',
      x: 0,
      y: 40,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.177305,
        y: 0.898917
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Big_Pop_Up_Background',
      parent: '9aaaf1b6-030f-4d79-bcf7-db93bec1bb3d',
      data: undefined,
      stateByName: {
        mainMenu: {
          scale: {
            y: 1.171053,
            x: 1
          },
          y: -8,
          texture: 'Small_Pop_Up_Background'
        }
      }
    },
    {
      id: '31c4b118-6d9a-49a2-bb99-3543ace30601',
      type: 'Sprite',
      runtimeType: null,
      name: 'header',
      className: '',
      x: 0,
      y: -301,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.85,
        y: 0.85
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Red_Header',
      parent: '9aaaf1b6-030f-4d79-bcf7-db93bec1bb3d',
      data: undefined,
      stateByName: {}
    },
    {
      id: '21667ec1-0a94-49f1-8ef4-6bf83d2df9ff',
      type: 'Sprite',
      runtimeType: null,
      name: 'messageContainer',
      className: '',
      x: 0,
      y: -70,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.85,
        y: 0.85
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: '',
      parent: '9aaaf1b6-030f-4d79-bcf7-db93bec1bb3d',
      data: undefined,
      stateByName: {}
    },
    {
      id: 'cdcac722-59fa-40d8-80ab-714ae71f49b1',
      type: 'Container',
      runtimeType: null,
      name: 'settingsGroups',
      className: '',
      x: 0,
      y: 70,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '9aaaf1b6-030f-4d79-bcf7-db93bec1bb3d',
      data: undefined,
      stateByName: {}
    },
    {
      id: '6110fb58-4e31-43e0-b59e-22367159183d',
      type: 'Text',
      runtimeType: null,
      name: 'title',
      className: '',
      x: -3,
      y: -9,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Notification',
      localize: true,
      maxWidth: 380,
      maxHeight: 0,
      maxFontSize: 0,
      style: {
        fontSize: 55,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '0x840025',
        strokeThickness: 7,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '31c4b118-6d9a-49a2-bb99-3543ace30601',
      data: undefined,
      stateByName: {}
    },
    {
      id: 'dfda3e54-39f2-4c6b-a62d-6499691f31ba',
      type: 'Text',
      runtimeType: null,
      name: 'txtMessage',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'notification_permission_message',
      localize: true,
      maxWidth: 580,
      maxHeight: 500,
      maxFontSize: 0,
      style: {
        fontSize: 46,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '0x840025',
        strokeThickness: 6,
        align: 'center',
        wordWrap: true,
        wordWrapWidth: 500,
        breakWords: true,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '21667ec1-0a94-49f1-8ef4-6bf83d2df9ff',
      data: undefined,
      stateByName: {}
    },
    {
      id: '6733a441-7a21-4724-aaf7-af7df7ef6d4c',
      type: 'Layout',
      runtimeType: null,
      name: 'okayButton',
      className: '',
      path: 'common/buttons/ButtonLargeLayout.ts',
      percentX: 0,
      percentY: 0,
      x: 0,
      y: 80,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: true,
      parent: 'cdcac722-59fa-40d8-80ab-714ae71f49b1',
      data: {
        color: 'green',
        tapSound: 'UI_Button_Click'
      },
      stateByName: {}
    },
    {
      id: '650265cf-0b92-4c54-96f3-e1ba57e9d04c',
      type: 'Container',
      runtimeType: null,
      name: 'cancelButton',
      className: '',
      x: 0,
      y: 218,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      parent: 'cdcac722-59fa-40d8-80ab-714ae71f49b1',
      data: {
        tapSound: 'UI_Button_Click'
      },
      stateByName: {
        mainMenu: {
          visible: false
        }
      }
    },
    {
      id: 'bc92c4b5-f4fc-4e87-9cc3-27d00b732343',
      type: 'Text',
      runtimeType: null,
      name: '',
      className: '',
      x: 0,
      y: -2,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Allow',
      localize: true,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      style: {
        fontSize: 50,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '0x00700c',
        strokeThickness: 7,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '6733a441-7a21-4724-aaf7-af7df7ef6d4c',
      data: undefined,
      stateByName: {}
    },
    {
      id: '3a8d983b-1263-4e98-9e50-a4a66d239892',
      type: 'NineSlicePlane',
      runtimeType: null,
      name: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 181,
        y: 70
      },
      width: 362,
      height: 139,
      leftWidth: 55,
      topHeight: 55,
      rightWidth: 55,
      bottomHeight: 55,
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Button_Background',
      parent: '650265cf-0b92-4c54-96f3-e1ba57e9d04c',
      data: undefined,
      stateByName: {}
    },
    {
      id: '26fca53f-907b-4ec7-88a4-416563f2fe4f',
      type: 'Layout',
      runtimeType: null,
      name: '',
      className: '',
      path: 'common/buttons/ButtonLargeLayout.ts',
      percentX: 0,
      percentY: 0,
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: true,
      parent: '650265cf-0b92-4c54-96f3-e1ba57e9d04c',
      data: {
        color: 'red'
      },
      stateByName: {}
    },
    {
      id: '3bfa7443-7e9e-4271-a77f-e109cc490930',
      type: 'Text',
      runtimeType: null,
      name: '',
      className: '',
      x: 0,
      y: -2,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Reject',
      localize: true,
      maxWidth: 298,
      maxHeight: 91,
      maxFontSize: 0,
      style: {
        fontSize: 40,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '0x9c1131',
        strokeThickness: 7,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '650265cf-0b92-4c54-96f3-e1ba57e9d04c',
      data: undefined,
      stateByName: {}
    }
  ],
  version: '1.0.0',
  stateNames: [
    'noSupportEmail',
    'mainMenu'
  ],
  animations: []
} as const;

export class NotificationPermissionPopupLayout {
  static raw = raw;
  root: Container;
  popup: Container;
  background: Sprite;
  header: Sprite;
  messageContainer: Sprite;
  settingsGroups: Container;
  title: Text;
  txtMessage: Text;
  okayButton: ButtonLargeLayout & { data: typeof raw['list'][8]['data'] };
  cancelButton: Container & { data: typeof raw['list'][9]['data'] };

  mInternalTypes: {
    Raw: typeof raw;
    StateName: 'noSupportEmail' | 'mainMenu';
    ModelByName: {
      root: typeof raw['list'][0];
      popup: typeof raw['list'][1];
      background: typeof raw['list'][2];
      header: typeof raw['list'][3];
      messageContainer: typeof raw['list'][4];
      settingsGroups: typeof raw['list'][5];
      title: typeof raw['list'][6];
      txtMessage: typeof raw['list'][7];
      okayButton: typeof raw['list'][8];
      cancelButton: typeof raw['list'][9];
    };
  };

  constructor() {
    populate(this, raw);
  }
}
